module.exports = __webpack_public_path__ + "static/fonts/Nunito-Regular.76a13a3.woff";